<template>
<div style="padding: 15px;height: 100vh; overflow: scroll; background: #2562af;" class="Kanit">
  <v-img src="/static/img/icons/logoonechat_full-white.png" style="max-width: 250px; margin:auto;"/>
  <!-- {{isSet==false}}{{isSet==''}} -->
  <v-menu offset-y style="z-index: 11; border-radius: 10px;display: flex;justify-content: center;" v-if="isSet==false">
    <div v-if="$i18n.locale == 'th'" slot="activator">
      <span style="color:white;">ภาษา :   </span><img src='/static/flag/thailand.svg' class="iconLanguage"/>
    </div>
    <div v-else slot="activator">
      <span style="color:white;">Language :   </span><img src='/static/flag/united-kingdom.svg' class="iconLanguage"/>
    </div>
    <!-- <img v-else-if="$i18n.locale == 'en'" slot="activator" src='/static/flag/united-kingdom.svg' class="iconLanguage"></img> -->
  <v-list style="border-radius: 10px;">
    <v-list-tile @click="changeLan('th')">
      <v-list-tile-title>
        <img src='/static/flag/thailand.svg' style="height: 20px;"/>&nbsp;&nbsp;ไทย
      </v-list-tile-title>

      </v-list-tile>
      <v-list-tile @click="changeLan('en')">
      <v-list-tile-title>
        <img src='/static/flag/united-kingdom.svg' style="height: 20px;"/>&nbsp;&nbsp;ENG
      </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>

<div v-if="isSet == undefined" class="bginform">
  <!-- ได้รับคำตอบแล้ว -->
  <v-container style="justify-content: center;display: grid;text-align: center;">
 <!--      <h2 class="mt-3 mb-2 indentText" style="justify-content: center; display: flex;">ได้รับข้อมูลเรียบร้อยแล้วค่ะ ขอบคุณที่ใช้บริการค่ะ</h2> -->
      <v-img src="/static/img/pagedefault/notfound.jpg" style="justify-self: center; width: 50vw;
    min-width: 250px;object-fit: cover;object-position: 50% 0;"> </v-img>
      <h2 class="mt-3 mb-2 indentText" style="justify-content: center; display: flex;">ไม่พบข้อมูลผู้ใช้งาน <br/>กรุณาติดต่อใหม่ในภายหลัง

      </h2>
    </v-container>

  </div>


 <div v-else-if="!isSet" class="bginform">
<v-flex xl12 lg12 md12 sm12 style="text-align: center;">
  <h2>{{$t('custsat.Header')}}</h2>
  <!-- <v-img src="/static/img/icons/logoonechat_full.png" style="max-width: 250px; margin:auto;"/> -->
</v-flex>

<v-flex xl12 lg12 md12 sm12 style="margin-top: 20px;">
  <span><b>{{$t('custsat.username')}}: </b>  {{email}} </span>       
</v-flex>
<v-flex xl12 lg12 md12 sm12 class="rowForm">
  <div>
<b>1. {{$t('custsat.ask_1.operation_system_1')}} <span style="color: red;">*</span></b> <span style="font-size: 12px; color: gray;">({{$t('custsat.ask_1.morethanone')}}) </span></div>
<div style="margin-left: 15px;">
   <v-checkbox v-model="android" hide-details :label="$t('custsat.ask_1.android')" color="#2562af"></v-checkbox>
   <v-checkbox v-model="ios" hide-details :label="$t('custsat.ask_1.ios')" color="#2562af"></v-checkbox>
   <v-checkbox v-model="website" hide-details :label="$t('custsat.ask_1.website')" color="#2562af"></v-checkbox>
  </div>
    
</v-flex>

<v-flex xl12 lg12 md12 sm12 class="rowForm">
  <div>
<b>2. {{$t('custsat.ask_2.frequencyUse')}} <span style="color: red;">*</span></b>
</div>
<div style="margin-left: 15px;">
    <v-radio-group v-model="frequencyUse" hide-details >
      <v-radio :value="1" color="#2562af" :label="$t('custsat.ask_2.option1')"></v-radio>
      <v-radio :value="2" color="#2562af" :label="$t('custsat.ask_2.option2')"></v-radio>
      <v-radio :value="3" color="#2562af" :label="$t('custsat.ask_2.option3')"></v-radio>
      <v-radio :value="4" color="#2562af" :label="$t('custsat.ask_2.option4')"></v-radio>
    </v-radio-group>
  </div>     
</v-flex>


<v-flex xl12 lg12 md12 sm12 class="rowForm">
  <div>
<b>3. {{$t('custsat.ask_3')}} <span style="color: red;">*</span></b> 
</div>
<div class="rate">
     <input type="radio" id="rateFunction5" :value="5" v-model="rateFunction"/>
    <label for="rateFunction5" title="text"></label>
    <input type="radio" id="rateFunction4" :value="4" v-model="rateFunction"/>
    <label for="rateFunction4" title="text"></label>
    <input type="radio" id="rateFunction3" :value="3" v-model="rateFunction"/>
    <label for="rateFunction3" title="text"></label>
    <input type="radio" id="rateFunction2" :value="2" v-model="rateFunction"/>
    <label for="rateFunction2" title="text"></label>
    <input type="radio" id="rateFunction1" :value="1" v-model="rateFunction"/>
    <label for="rateFunction1" title="text"></label>
  </div>
  <span v-if="rateFunction != 0" style="vertical-align: middle;line-height: 46px;">({{rateFunction}} {{$t('custsat.point')}})</span>    
</v-flex>

<v-flex xl12 lg12 md12 sm12 class="rowForm">
    <div>
<b>4. {{$t('custsat.ask_4')}} <span style="color: red;">*</span></b> <!-- ({{rateSpeedResponse}}) -->
</div>
<div class="rate">
    <input type="radio" id="rateSpeedResponse5" :value="5" v-model="rateSpeedResponse"/>
    <label for="rateSpeedResponse5" title="text"></label>
    <input type="radio" id="rateSpeedResponse4" :value="4" v-model="rateSpeedResponse"/>
    <label for="rateSpeedResponse4" title="text"></label>
    <input type="radio" id="rateSpeedResponse3" :value="3" v-model="rateSpeedResponse"/>
    <label for="rateSpeedResponse3" title="text"></label>
    <input type="radio" id="rateSpeedResponse2" :value="2" v-model="rateSpeedResponse"/>
    <label for="rateSpeedResponse2" title="text"></label>
    <input type="radio" id="rateSpeedResponse1" :value="1" v-model="rateSpeedResponse"/>
    <label for="rateSpeedResponse1" title="text"></label>
  </div>  
  <span v-if="rateSpeedResponse != 0" style="vertical-align: middle;line-height: 46px;">({{rateSpeedResponse}} {{$t('custsat.point')}})</span>   
</v-flex>

<v-flex xl12 lg12 md12 sm12 class="rowForm">
  <div>
<b>5. {{$t('custsat.ask_5')}} <span style="color: red;">*</span></b><!-- ({{rateOfficer}}) -->
</div>
<div class="rate">
    <input type="radio" id="rateOfficer5" :value="5" v-model="rateOfficer"/>
    <label for="rateOfficer5" title="text"></label>
    <input type="radio" id="rateOfficer4" :value="4" v-model="rateOfficer"/>
    <label for="rateOfficer4" title="text"></label>
    <input type="radio" id="rateOfficer3" :value="3" v-model="rateOfficer"/>
    <label for="rateOfficer3" title="text"></label>
    <input type="radio" id="rateOfficer2" :value="2" v-model="rateOfficer"/>
    <label for="rateOfficer2" title="text"></label>
    <input type="radio" id="rateOfficer1" :value="1" v-model="rateOfficer"/>
    <label for="rateOfficer1" title="text"></label>
  </div>     
  <span v-if="rateOfficer != 0" style="vertical-align: middle;line-height: 46px;">({{rateOfficer}} {{$t('custsat.point')}})</span>  
</v-flex>

<v-flex xl12 lg12 md12 sm12 class="rowForm">
  <div>
<b>{{$t('custsat.comment')}}</b>
</div>
<div >
    <v-textarea
          v-model="feedback"
          :placeholder="$t('custsat.comment')"
          full-width
          class="InputEdit"
          style="height: 120px;resize: none; margin-bottom: 15px;"
        ></v-textarea>
  </div>     
</v-flex>


<v-flex xl12 lg12 md12 sm12 class="rowForm" style="text-align: center;display: block;">
  <!-- <div> -->
<v-btn style="background: #2562af; color: white; border-radius: 10px;" :disabled="!checkdisabled()" @click="sendform()">{{$t('custsat.send')}}</v-btn>
  <!-- </div>      -->
</v-flex>
</div>


<div v-else-if="isSet" class="bginform">
  <!-- ได้รับคำตอบแล้ว -->
  <v-container style="justify-content: center;display: grid;text-align: center;">
 <!--      <h2 class="mt-3 mb-2 indentText" style="justify-content: center; display: flex;">ได้รับข้อมูลเรียบร้อยแล้วค่ะ ขอบคุณที่ใช้บริการค่ะ</h2> -->
      <v-img src="/static/img/custsat/celebration.png" style="justify-self: center; width: 50vw;
    min-width: 250px;object-fit: cover;object-position: 50% 0;"> </v-img>
      <h2 class="mt-3 mb-2 indentText" style="justify-content: center; display: flex;">ขอบคุณสำหรับการตอบคำถามนะคะ <br/> เราจะนำคำแนะนำไปปรับปรุงบริการให้ดีขึ้น

      </h2>
    </v-container>

  </div>


</div>
</template>

<script>


export default {
  data: () => ({
    email: '',
    android: false,
    ios: false,
    website: false,
    frequencyUse: 0,
    rateFunction: 0,
    rateSpeedResponse: 0,
    rateOfficer: 0,
    feedback: '',
    onechat_token: '',
    isSet: undefined
  }),
  components: {
  },
  created() {
    this.onechat_token = this.$route.query.onechat_token
    this.checkform(this.$route.query.onechat_token)
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  methods: {
    changeLan (lang) {
      this.$i18n.locale = lang
    },
    checkdisabled () {
      return (this.android || this.ios || this.website) && (this.frequencyUse != 0) && (this.rateFunction != 0) && (this.rateSpeedResponse != 0) && (this.rateOfficer != 0)
    },
    sendform () {
      this.axios.post(process.env.APIalpine + '/api/v1/cussat/set', {
        onechat_token: this.onechat_token,
        ios: this.ios,
        android: this.android,
        web: this.website,
        frequency: this.frequencyUse,
        function: this.rateFunction,
        performance: this.rateSpeedResponse,
        support: this.rateOfficer,
        comment: this.feedback
      }).then((response) => {
        console.log(response.data)
        this.isSet = true
      })
    },
    checkform (onechattoken) {
      this.axios.post(process.env.APIalpine + '/api/v1/cussat/get', {
        onechat_token: onechattoken
      }).then((response) => {
        // console.log(response.data.isSet)
        this.isSet = response.data.isSet
        this.email = response.data.email
      })
    }
    
  }
}
</script>

<style type="text/css" scoped>
.Kanit {
  font-family: 'Kanit' !important;
  word-wrap: break-word;
}
.rate {
  float: left;
  /*text-align: left;*/
    height: 46px;
    padding: 0 10px;
}
.rate:not(:checked) > input {
    position:absolute;
    top:-9999px;
}
.rate:not(:checked) > label {
   float: right;
    width:1em;
    overflow:hidden;
    white-space:nowrap;
    cursor:pointer;
    font-size:30px;
    color:#ccc;
}
.rate:not(:checked) > label:before {
    content: '★ ';
}
.rate > input:checked ~ label {
    color: #ffc700;    
}
.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
    color: #deb217;  
}
.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
    color: #c59b08;
}

.rowForm {
  margin-top: 10px;
  display: table;
}
.InputEdit {
    height: 43px;
    width: calc(100vw - 50px);
    max-width: 500px;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}

>>>.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
     margin-bottom: 0px !important; 
}


>>>.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    /* padding-right: 12px; */
    /*font-size: 14px;*/
    font-size: 14px;
    resize: none;
    height: 75px !important;
}
>>>.v-text-field.v-text-field--full-width.v-input {
    padding: 0;
    padding-left: 10px !important;
}
>>>.v-input--selection-controls.v-input .v-label {
    font-size: 14px !important;
    color: #202020 !important;
}
>>>.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}
.bginform {
    background: white;
    padding: 10px;
    border-radius: 15px;
}

  select, textarea, input {
    width: 100%;
    font-size: 16px;
  }

  select:focus, textarea:focus, input:focus {
    width: 100%;
    font-size: 16px;
  }
  input[type=text]:focus {
    width: 100%;
    font-size: 16px;
  }
  .iconLanguage {
  height: 25px;
  cursor: pointer;
  margin-top: 7px;
}

</style>



// WEBPACK FOOTER //
// src/components/custsat/custsat.vue